export * from "./ArrowDown";
export * from "./ArrowUp";
export * from "./BigFlip";
export * from "./Backspace";
export * from "./Bell";
export * from "./BeneficiaryList";
export * from "./Calendar";
export * from "./ContactBook";
export * from "./Copy";
export * from "./Delete";
export * from "./DeleteNumpad";
export * from "./Download";
export * from "./DevPassword";
export * from "./Edit";
export * from "./EditAccountData";
export * from "./Email";
export * from "./Filter";
export * from "./Gallery";
export * from "./GiveRating";
export * from "./Hamburger";
export * from "./Identity";
export * from "./Language";
export * from "./Location";
export * from "./LogOut";
export * from "./Maps";
export * from "./MeatballMenu";
export * from "./Money";
export * from "./MobilePhone";
export * from "./PersonalInformation";
export * from "./Password";
export * from "./Phone";
export * from "./Pin";
export * from "./PrivacyPolicy";
export * from "./Refresh";
export * from "./ReferFriend";
export * from "./Search";
export * from "./SelfieWithId";
export * from "./Selfie";
export * from "./Share";
export * from "./TakePhoto";
export * from "./TnC";
export * from "./Star";
export * from "./StarOutline";
export * from "./WriteNotes";
export * from "./UploadFile";
export * from "./LinkIcon";
export * from "./Upload";
export * from "./KYC";
export * from "./ScrollMore";
export * from "./Biometric";
export * from "./BiometricFace";
